import { Action } from '@ngrx/store';
import { MonitorFilter } from './state';

export enum MonitorFiltersActionTypes {
  Set = '[Monitor Filters] Set',
  Reset = '[Monitor Filters] Reset'
}

export class MonitorFiltersSet implements Action {
  public readonly type = MonitorFiltersActionTypes.Set;
  constructor(public payload: { name: string; value: MonitorFilter }) {}
}

export class MonitorFiltersReset implements Action {
  public readonly type = MonitorFiltersActionTypes.Reset;
  constructor(public payload?: { name: string; value: MonitorFilter }) {}
}

export type MonitorFiltersActionUnion = MonitorFiltersSet | MonitorFiltersReset;
